import React, {useState, useRef, useEffect} from 'react'

import { observer } from 'mobx-react';

import Aep from '../Aep/Aep'
import Indicator from './Indicator/Indicator'
import Tab from './Tab'

import {store} from '../../stores/store'

import './aep-popup.css'

import GainsAndCostsChart from './WarehouseCharts/GainsAndCostsChart/GainsAndCostsChart';
import WorkloadChart from './WarehouseCharts/WorkloadChart/WorkloadChart';
import CropProductionChart from './WarehouseCharts/CropProductionChart/CropProductionChart';

import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import AepsPool from '../../js/AepsPool';
import IndicatorsPool from '../../js/IndicatorsPool';

function closePopup() {
  PopupStore.close(POPUPS_IDS.AEPS)
}

function AepPopup({data}) {

  const [selectedTab, setSelectedTab] = useState(data.categs[0]);

  let aepsRef = useRef(null)
  let indsRef = useRef(null)

  useEffect(() => {
    const opts = { top: 0, behavior: 'smooth'}
    aepsRef.current && aepsRef.current.scrollTo(opts)
    indsRef.current.scrollTo(opts)
  }, [selectedTab]);


  let tabs = data.categs
  let aepCateg = AepsPool.getCateg(selectedTab)

  let aeps = aepCateg ? aepCateg.aeps : null
  let name = aepCateg ? aepCateg.name : null


  let selectedAepId = store.getSelectedAepId(name)
  let prevSelectedAepId = store.getPrevSelectedAepId(name)

  let aepCategIndex = tabs.findIndex(tab => tab === selectedTab)
  let indicators = data.indicators[aepCategIndex].map(indId => {
    let ind = IndicatorsPool.getIndicator(indId)
    let val = IndicatorsPool.getIndicatorValue(indId, true)
    return [ind, val]
  })
  .filter(([ind, val]) => !(parseFloat(val) === 0 && !ind.show_if_null))


  let popupname = store.t(data.id)
  let customContent = data.custom_content_id[aepCategIndex]

  return (
    <div className="aep-popup-ctnr">
      <div className="overlay" onClick={closePopup}></div>

      <div className="aep-popup">

        <div className="title">
          <span className={"icon " + data.id}></span>
          <span className="title-text">{popupname}</span>
          <span className="close-button" onClick={closePopup} />
        </div>

        <div className="content">

          { tabs &&
          <div className="tabs" onClick={closePopup}>
            {tabs.map( tab => (
            <Tab onClick={()=>{setSelectedTab(tab)}} selected={tab === selectedTab} key={tab} >
              {store.t(tab)}
            </Tab>))}
          </div>}

          { aeps &&
          <div className="col" ref={aepsRef}>
            <div className="aeps">
              {aeps.map((aep, i) => {
                return (
                <Aep
                  categ={name}
                  onClick={() => {store.setSelectedAep(name, aep.id)}}
                  selected={aep.id === selectedAepId}
                  prevSelected={aep.id === prevSelectedAepId}
                  data={aep}
                  key={i} />)
              })}
            </div>
          </div> }

          { (indicators || customContent) &&
            <div className="col" ref={indsRef}>
              {customContent &&<div className="custom_content">
                {customContent === "gains_and_costs" && <GainsAndCostsChart />}
                {customContent === "crop_production" && <CropProductionChart />}
                {customContent === "workload" && <WorkloadChart />}
              </div>}

              {indicators.length > 0 &&
              <div className="indicators" >
                {indicators.map(([ind, val], index) => (<Indicator data={ind} value={val} key={ind.id} />))}
              </div>}
            </div>}



        </div>

      </div>
    </div>
  )
}

export default observer(AepPopup)
